import { Route, Routes } from 'react-router-dom';
import ConfirmDash from '../pages/leave/leave-confirm-dashboard';
import Page404 from '../pages/error/page-404'
// import AttendanceAeropolis from '../pages/attendance-aeropolis';
// import Order from '../pages/Order';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/confirm-leave-req/cfm/:p1" element={<ConfirmDash />} />
      <Route path="*" element={<Page404 />} />
    </Routes>
  );
};

export default AppRoutes;